import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Grid,
  Typography,
} from "@material-ui/core";
import intl from "react-intl-universal";

import { IWithballData } from "types";
import {
  buildMatrixFromPassData,
  summarisePass,
  calculatePecentage,
} from "utils";

import { StatisticsBoard } from "components/StatisticsBoard";

import { PassTableCell } from "./";

interface IPassPanel {
  dataArray: IWithballData[];
}

interface PlayerCell {
  id: string;
  name: string;
}

const findMax = (matrix: any): number => {
  var max = 0;
  Object.keys(matrix).map((fromPlayerId) => {
    matrix[fromPlayerId].map((each: any) => {
      if (each.succ > max) {
        max = each.succ;
      }
      return null;
    });
    return null;
  });
  return max;
};

export const PassPanel = ({ dataArray }: IPassPanel) => {
  const { summary, matrix } = useMemo(() => {
    return {
      summary: summarisePass(dataArray),
      matrix: buildMatrixFromPassData(dataArray),
    };
  }, [dataArray]);

  const maxPass = findMax(matrix);

  const rowPlayers: PlayerCell[] = [];
  const colPlayers: PlayerCell[] = [];
  Object.getOwnPropertyNames(matrix).map((playerId) => {
    rowPlayers.push({
      id: playerId,
      name: matrix[playerId][0].fromName,
    });
    matrix[playerId].map((each: IWithballData) => {
      if (
        !colPlayers.find((player) => player.id === each.toPlayer.toString())
      ) {
        colPlayers.push({
          id: each.toPlayer.toString(),
          name: each.toName || "",
        });
      }
      return null;
    });
    return null;
  });

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              {intl.get("MATCH_TEAM_OVERVIEW_TABLE_DESC")}
            </TableCell>
            {colPlayers.map((player) => (
              <TableCell key={player.id} align="center">
                {player.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowPlayers.map((rowPlayer) => (
            <TableRow key={rowPlayer.id}>
              <TableCell component="th" scope="row" align="center">
                {rowPlayer.name}
              </TableCell>
              {colPlayers.map((colPlayer) => (
                <PassTableCell
                  key={colPlayer.id}
                  rowPlayer={rowPlayer}
                  colPlayer={colPlayer}
                  matrix={matrix}
                  max={maxPass}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography>{`${intl.get("MATCH_TEAM_OVERVIEW_PASS_TOTAL")}: ${
            summary.total
          }`}</Typography>
          <Typography>{`${intl.get("MATCH_TEAM_OVERVIEW_PASS_SUCC")}: ${
            summary.succ
          }`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_PASS_SUCC_RATE"
          )}: ${calculatePecentage(summary.succ, summary.total)}`}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_OWN_HALF_PASS_TOTAL"
          )}: ${summary.selfHalf.total}`}</Typography>
          <Typography>{`${intl.get("MATCH_TEAM_OVERVIEW_PASS_SUCC")}: ${
            summary.selfHalf.succ
          }`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_PASS_SUCC_RATE"
          )}: ${calculatePecentage(
            summary.selfHalf.succ,
            summary.selfHalf.total
          )}`}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_OTHER_HALF_PASS_TOTAL"
          )}: ${summary.otherHalf.total}`}</Typography>
          <Typography>{`${intl.get("MATCH_TEAM_OVERVIEW_PASS_SUCC")}: ${
            summary.otherHalf.succ
          }`}</Typography>
          <Typography>{`${intl.get(
            "MATCH_TEAM_OVERVIEW_PASS_SUCC_RATE"
          )}: ${calculatePecentage(
            summary.otherHalf.succ,
            summary.otherHalf.total
          )}`}</Typography>
        </Grid>
      </Grid>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <StatisticsBoard data={dataArray} />
        </Grid>
      </Grid>
    </>
  );
};
